import { render } from "./CountyInfoForm.vue?vue&type=template&id=423a5ef2"
import script from "./CountyInfoForm.vue?vue&type=script&lang=ts"
export * from "./CountyInfoForm.vue?vue&type=script&lang=ts"
script.render = render

export default script